import React from 'react';

const FooterSection = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="px-4 py-8 bg-white border-t border-slate-200 text-[11px] md:text-xs text-slate-500">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-3 md:gap-0">
        <div className="flex items-center gap-2">
          <img
            src="/favicon.png"
            alt="CleanBid logo"
            className="h-6 w-6 rounded-md shadow-sm"
          />
          <span className="font-semibold text-slate-800">CleanBid</span>
        </div>

        <div className="flex items-center gap-4">
          <a href="/" className="hover:text-slate-900 transition-colors">Home</a>
          <a href="/privacy" className="hover:text-slate-900 transition-colors">Privacy</a>
          <a href="/terms" className="hover:text-slate-900 transition-colors">Terms</a>
        </div>

        <div className="text-slate-500">
          © {year} CleanBid.ai. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
